module.exports = __webpack_public_path__ + "img/r-4.cb221a89.jpg";